import React from "react";
import H1 from "~/components/H1";


interface Props {
  name: string,
  description?: string|null,
  // children: React.ReactNode,
}

const ToolHeaderNew: React.FC<Props> = (
  {
    name,
    description = null,
    // children = null,
  }
) => {
  return (
    <>
      <header className="mx-auto py-2 md:py-6 text-center max-w-[900px]">
        <H1 className="md:text-5xl">{name}</H1>
        {description !== null && description !== "" ? (
          <p className="pt-4 text-lg md:text-xl">
            {description.endsWith(".") || description.endsWith("?") || description.endsWith("!") ? description : description + "."}
          </p>
        ) : null}
      </header>
    </>
  );
};

export default ToolHeaderNew;